<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.TITLE' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">book</mat-icon>
  </p>
  <div class="container mx-auto p-4">
    <mat-accordion>
      @for (tutoriel of tutoriels; track tutoriel) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="material-symbols-outlined mr-2">menu_book</mat-icon>
              {{ tutoriel.titre | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="p-4">
            @if (tutoriel.nomFichierBase) {
              <div>
                <p class="mb-4">
                  {{ 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.DESCRIPTION' | translate }}
                </p>
                <button mat-raised-button color="warn" (click)="ouvrirTutoriel(tutoriel, 'fr')"
                  [disabled]="chargementTutoriel[tutoriel.cle + '_fr']" class="mb-4 mr-2">
                  @if (chargementTutoriel[tutoriel.cle + '_fr']) {
                    <mat-spinner diameter="20"
                      class="inline-block mr-2">
                    </mat-spinner>
                  }
                  @if (!chargementTutoriel[tutoriel.cle + '_fr']) {
                    <mat-icon class="mr-2">picture_as_pdf</mat-icon>
                  }
                  {{ 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.OUVRIR_TUTORIEL_PDF' | translate }} (FR)
                </button>
                <button mat-raised-button color="warn" (click)="ouvrirTutoriel(tutoriel, 'en')"
                  [disabled]="chargementTutoriel[tutoriel.cle + '_en']" class="mb-4">
                  @if (chargementTutoriel[tutoriel.cle + '_en']) {
                    <mat-spinner diameter="20"
                      class="inline-block mr-2">
                    </mat-spinner>
                  }
                  @if (!chargementTutoriel[tutoriel.cle + '_en']) {
                    <mat-icon class="mr-2">picture_as_pdf</mat-icon>
                  }
                  {{ 'AIDE_ET_SOUTIEN.TUTORIELS_SECTION.OUVRIR_TUTORIEL_PDF' | translate }} (EN)
                </button>
              </div>
            }
            @if (tutoriel.vimeoIds && tutoriel.vimeoIds.length > 0) {
              <div class="videos-section">
                @for (vimeoId of tutoriel.vimeoIds; track vimeoId; let i = $index) {
                  <app-tutoriel-video-player
                    [vimeoId]="vimeoId">
                  </app-tutoriel-video-player>
                }
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>